import { Pagination } from '@celltrak/ui-components';

import { useAction } from '../../../Common/hooks';
import { setVisitsFilters } from '../../actions';

import usePagination from './hooks';

const Paginator = () => {
  const { numberOfPages, pagesPerSegment, pageNumber } = usePagination();
  const dispatchSetVisitsFilters = useAction(setVisitsFilters);

  return (
    <Pagination
      size="sm"
      id="visit-reports-pager"
      pages={numberOfPages}
      activePage={pageNumber}
      pagesPerSegment={pagesPerSegment}
      onPageClick={page => dispatchSetVisitsFilters({ pageNumber: page })}
      onFirstClick={() => dispatchSetVisitsFilters({ pageNumber: 1 })}
      onPrevClick={() => dispatchSetVisitsFilters({ pageNumber: pageNumber - 1 })}
      onNextClick={() => dispatchSetVisitsFilters({ pageNumber: pageNumber + 1 })}
      onLastClick={() => dispatchSetVisitsFilters({ pageNumber: numberOfPages })}
    />
  );
};

export default Paginator;
